import fp3d from "./plan-3d.jpg";
import fp2d from "./plan-2d.jpg";
import fpSchema from "./plan-schema.jpg";

const photoModules = import.meta.glob('./img-*.jpg', { eager: true, import: 'default' }) as Record<string, string>;

export const stodulkyBytImages: string[] = Object.entries(photoModules)
  .sort(([a], [b]) => {
    const na = parseInt(a.match(/img-(\d+)/)?.[1] || "0");
    const nb = parseInt(b.match(/img-(\d+)/)?.[1] || "0");
    return na - nb;
  })
  .map(([, src]) => src);

export const stodulkyBytFloorPlans: { image: string; label: string }[] = [
  { image: fp3d, label: "Půdorys – 3D" },
  { image: fp2d, label: "Půdorys – 2D" },
  { image: fpSchema, label: "Půdorys – schéma" },
];
